export default __webpack_public_path__ + "static/media/museumback.e532059f.png";